import {
    GET_SEATS,
    GET_SEAT_LIMIT,
    GET_USERS,
    SET_SEATS,
    SET_SEAT_LIMIT,
} from "./types";
import firebase from "firebase/app";

export const getSeats = () => {
    return (dispatch) => {
        dispatch({ type: GET_SEATS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_SEATS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/seated_users")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_SEATS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_SEATS.FAIL });
        }
    };
};
export const getSeatLimit = () => {
    return (dispatch) => {
        dispatch({ type: GET_SEAT_LIMIT.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_SEAT_LIMIT.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/seated_user_limit")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_SEAT_LIMIT.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_SEAT_LIMIT.FAIL });
        }
    };
};
export const getUsers = () => {
    return (dispatch) => {
        dispatch({ type: GET_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_USERS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/users")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};
export const saveChanges = (seats, limit) => {
    return (dispatch) => {
        dispatch({ type: SET_SEATS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SET_SEATS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/seated_users")
                        .set(seats);
                    firebase
                        .database()
                        .ref("/collections/seated_user_limit")
                        .set(limit);
                    dispatch({
                        type: SET_SEATS.SUCCESS,
                    });
                }
            });
        } catch (e) {
            dispatch({ type: SET_SEATS.FAIL });
        }
    };
};
export const updateLimit = (limit) => {
    return (dispatch) => {
        dispatch({ type: SET_SEAT_LIMIT, payload: limit });
    };
};
